import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// import store from './store'

import { VueClipboard } from "@soerenmartius/vue3-clipboard"; //https://www.npmjs.com/package/@soerenmartius/vue3-clipboard

// import AppConfig from "@/config/vueconfig.js";
//import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import Tracking from "@/plugins/Tracking.js";
import Filter from "@/plugins/Filter.js";

import './index.css';
import "@splidejs/splide/dist/css/splide.min.css";

createApp(App)
    // .use(store)
    .use(router)
    .use(Tracking)
    .use(Filter)
    .use(VueClipboard)
    //.mixin(ErrorApiMixin)
    .mount('#app')
